module.exports = __webpack_public_path__ + "static/step-getting-vascepa-6c74f4d19398121c52ac5c5885b55f4c.png";